module.exports = __webpack_public_path__ + "media/club_product_v2/1-4f93b214.webp";